export const contactPt = {
  embed: {
    infoTitle: 'Informações de contato',
    phone: 'Telefone',
    email: 'E-mail',
    scheduleTitle: 'Horário de atendimento',
    scheduleWeekdays: 'Segunda a Sexta: 9:00 - 18:00',
    scheduleSaturday: 'Sábado: 10:00 - 14:00',
  },
};
